export default __webpack_public_path__ + "locales/fr/FilesSettings.json?hash=56a733bd966d2346dad5b3f07579b88a";